import React, { useCallback, useState } from 'react';
import Head from 'next/head';
import QRCode from 'qrcode.react';
import classNames from 'classnames';
import { debounce } from 'lodash-es';

import styles from './NewsShare.module.scss';
import { copy } from '../../util/copy';
import toast from './toast';

interface IProps {
  newsNo: string;
  qrCodeText: string;
  copyUrlSuccessText: string;
  copyUrlFailedText: string;
}

export default function NewsShare(props: IProps) {
  const [popoverShow, setPopoverShow] = useState(false);
  const {
    newsNo,
    qrCodeText = '微信扫码分享',
    copyUrlSuccessText = '复制链接成功',
    copyUrlFailedText = '复制链接失败，请重试',
  } = props;

  const genShareUrl = useCallback(
    (source: string) => {
      if (typeof window === 'object') {
        return `${window.origin}/news/${newsNo}?source=${source}`;
      }
      return '';
    },
    [newsNo],
  );
  const qrcodeShareUrl = genShareUrl('QRcode');
  const copyShareUrl = genShareUrl('shareURLs');

  const handleCopy = debounce(async () => {
    let content: string;
    try {
      await copy(copyShareUrl);
      content = copyUrlSuccessText;
    } catch (e) {
      content = copyUrlFailedText;
    }
    toast({ content });
  }, 200);

  return (
    <>
      <Head>
        <link rel="preload" as="image" href="https://s3plus.meituan.net/smart/sharewechat-hover.svg" />
        <link rel="preload" as="image" href="https://s3plus.meituan.net/smart/copyurl-hover.svg" />
      </Head>
      <div className="relative ml-6 h-fit rounded-[10px] border border-black-6 p-1">
        <div
          onFocus={() => 0}
          onMouseOver={() => setPopoverShow(true)}
          onMouseLeave={() => setPopoverShow(false)}
          className="mb-1 h-12 w-12 cursor-pointer rounded-md bg-[url('https://s3plus.meituan.net/smart/sharewechat.svg')] bg-center bg-no-repeat hover:bg-black-5 hover:bg-[url('https://s3plus.meituan.net/smart/sharewechat-hover.svg')]"
        />
        <div className="mx-auto h-[1px] w-6 bg-black-6" />
        <div
          onClick={handleCopy}
          className="mt-1 h-12 w-12 cursor-pointer rounded-md bg-[url('https://s3plus.meituan.net/smart/copyurl.svg')] bg-center bg-no-repeat hover:bg-black-5 hover:bg-[url('https://s3plus.meituan.net/smart/copyurl-hover.svg')]"
        />

        <div className={classNames(styles.sharePopover, { [styles.show]: popoverShow })}>
          <QRCode size={98} value={qrcodeShareUrl} />
          <div className={styles.shareText}>{qrCodeText}</div>
        </div>
      </div>
    </>
  );
}
